<template>
    <b-container v-if="page">
        <b-row class="mt-5">
            <b-col>
                <b-breadcrumb class="p-0 my-1" :items="breadcrumbs"/>
                <h2>{{page.contentDataSet.title.value}}
                    <hr class="left mt-1 mb-4"/>
                </h2>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-html="page.contentDataSet.content.value">
                {{page.contentDataSet.content.value}}
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'html-only-content',
        data: function () {
            return {
                page: null,
            }
        },
        beforeRouteUpdate(to, from, next) {
            ContentAPI.fetchPageByName(to.params.resource).then(result => {
                this.page = result;
            });
            next();
        },
        mounted() {
            ContentAPI.fetchPageByName(this.$route.params.resource).then(result => {
                this.page = result;
            })
        },
        computed: {
            breadcrumbs() {
                return [{
                    text: 'Home',
                    href: '/'
                }, {
                    text: this.page.contentDataSet.title.value,
                    href: ''
                }]
            },
        }
    }
</script>